import { SET_APPOINTMENT_DETAILS, RESET_RESPONSE_APPOINTMENT } from "./types";

export function setAppointmentDetails(data) {
  return {
    type: SET_APPOINTMENT_DETAILS,
    payload: data,
  };
}
export function resetAppointmentDetails() {
  return { type: RESET_RESPONSE_APPOINTMENT };
}
